import React, { FC, useEffect, useState } from 'react'
import { DetailFertilisation } from './fertilisation.types'
import { getFertilisationsByPlanche } from './fertilisation.api'
import { FormattedMessage } from 'react-intl'
import { compose } from 'redux'
import { injectProduitFertilisationValueList } from '../../../../common/valueLists/valueListInjectors'
import { LocalDate } from '../../../../../utils/date/local-date'
import { Grid } from '@material-ui/core'
import { DateFormat } from '../../../../../utils/date/model/date'
import { ValueListEntry } from '../../../../../utils/types/global.types'

type DetailFertilisationProps = {
	plancheId: string
	produitFertilisationList: ValueListEntry[]
}

const FertilisationSection: FC<DetailFertilisationProps> = ({ plancheId, produitFertilisationList }) => {
	const [fertilisationList, setFertilisationList] = useState<DetailFertilisation[]>([])

	useEffect(() => {
		getFertilisationsByPlanche(plancheId)
			.then(setFertilisationList)
	}, [plancheId])

	const getProduitLabel = (code: string) =>
		produitFertilisationList.find(p => p.code === code)?.label ?? ''

	if (fertilisationList.length === 0) {
		return <FormattedMessage id="planning.planche.detail.fertilization.none" />
	}

	return <Grid container>
		{fertilisationList.map(f =>
			<Grid item key={f.id}>
				<FormattedMessage
					id="planning.planche.detail.fertilization.item"
					values={{
						quantite: `${f.quantite}`.replace('.', ','),
						produit: getProduitLabel(f.produit),
						date: LocalDate.fromAPI(f.date).format(DateFormat.SHORT_DATE),
						user: f.userModification ?? f.userCreation
					}}
				/>
			</Grid>
		)}
	</Grid>
}


type FertilisationSectionParentProps = {
	plancheId: string
}

export default compose<FC<FertilisationSectionParentProps>>(
	injectProduitFertilisationValueList
)(FertilisationSection)